import { SignupForm } from '@bvi/dashboard/feature/auth/ui/signup-form';

export const SignupPage = () => {
  return <SignupForm />;
};
